// Generated by brand/gen_icons.py — edit the constants there, not this file.
// The Matlist mark in its 100-unit box; Wordmark.tsx draws it inline so its
// stroke can follow the colour scheme.

export const MARK_PATH = 'M14 74 V48 a12 12 0 0 1 24 0 V74 M38 48 a12 12 0 0 1 24 0 V74 L88 36'
export const MARK_STROKE = 10.5
/** Applied inside the box, as in every brand SVG. */
export const MARK_TRANSFORM = 'translate(-1 -5)'
/** The stroke's visual bounds in the box: x, y, width, height. */
export const MARK_BOUNDS = [7.75, 25.75, 84.5, 48.5] as const
